<template>
	<div >
		<a-spin :spinning="loading">
			<div class="ft20 cl-main ftw600">预约时间设置</div>
			<div class="mt20">
				<div class="bg-w pd40" style="min-height: 800px;">
					<a-form-model :model="form" :label-col="labelCol" :wrapper-col="wrapperCol">
						<a-form-model-item label="可预约时间" required>
							<div class="flex wrap alcenter">
								<template v-for="(item,index) in weeks">
									<div class="flex alcenter cl-main mr20 mb20 clickAct"  @click="removeWeek(index)" v-if="form.week.indexOf(item.id) != -1">
										<div class="week-choose">
											<i class="iconfont iconduihao cl-w ft12"/>
										</div>
										<div class="ml8 ft14 ftw400 cl-theme">{{item.name}}</div>
									</div>
									<div class="flex alcenter cl-main mr20 mb20 clickAct" @click="addWeek(index)" v-else>
										<div class="week-no-choose"></div>
										<div class="ml8 ft14 ftw400">{{item.name}}</div>
									</div>
								</template>
							</div>
						</a-form-model-item>
						
						<a-form-model-item label="预约起始时间" required v-if="!loading">
							<select-time-range v-model="form.appoint_time"></select-time-range>
						</a-form-model-item>
						
						<a-form-model-item label="预约时间间隔" required>
							<div class="flex alcenter wrap">
								<template v-for="(item,index) in appointment_intervals">
									<div class="appointment-interval-item active" v-if="item.interval==form.appointment_interval">{{item.info}}</div>
									<div class="appointment-interval-item" v-else @click="chooseAppointmentIntervalsAct(index)">{{item.info}}</div>
								</template>
								
							</div>
						</a-form-model-item>
						
						<a-form-model-item label="同时段预约数" required>
							<a-input-number :formatter="value => `${value} 人`" v-model="form.appointment_num" :min="0" :precision="0"
							 placeholder="请输入同时段预约数" style="width: 150px;"  />
						</a-form-model-item>
						
						<a-form-model-item label="预约提前" required>
							<a-input-number :formatter="value => `${value} 小时`" v-model="form.appointment_advance" :min="0" :precision="0"
							  style="width: 150px;"  />
						</a-form-model-item>
						
						<a-form-model-item label="校验用户是否拥有项目" required>
							<a-radio-group name="radioGroup" class="ml15" v-model="form.check_member_project">
								<a-radio :value="1">
									是
								</a-radio>
								<a-radio :value="0">
									否
								</a-radio>
							</a-radio-group>
						</a-form-model-item>
						<a-form-model-item label="技师别称" help="如果您不想叫您的技师为技师可以在这里更改名称" required>
							<a-input type="text" style="width: 200px;" v-model="form.artificer"></a-input>
						</a-form-model-item>	
						
						<a-form-model-item label="休息公告" required>
							 <a-textarea placeholder="请输入公告内容" style="width: 600px;" :rows="2" v-model="form.rest_notice"/>
						</a-form-model-item>
						
						<a-form-model-item :wrapper-col="{ span: 2, offset: 3 }" class="mt20">
							<a-button type="primary" @click="onSubmit" :loading="confirmLoading">
								保存
							</a-button>
												
						</a-form-model-item>
					</a-form-model>
				</div>
			</div>
		</a-spin>
	</div>
</template>

<script>
	import selectTimeRange from './components/order/modal/addAppointment/selectTimeRange.vue';
	export default{
		components:{
			selectTimeRange
		},
		data(){
			return{
				loading:false,
				confirmLoading:false,
				labelCol: { span: 3 },
				wrapperCol: { span: 21 },
				weeks:[
					{id:1,name:'周一'},
					{id:2,name:'周二'},
					{id:3,name:'周三'},
					{id:4,name:'周四'},
					{id:5,name:'周五'},
					{id:6,name:'周六'},
					{id:0,name:'周日'},
				],
				appointment_intervals:[
					{interval:20,info:'20分钟'},
					{interval:30,info:'30分钟'},
					{interval:50,info:'50分钟'},
					{interval:60,info:'1小时'},
					{interval:90,info:'90分钟'},
					{interval:120,info:'2小时'}
				],
				form:{
					appoint_time:[],
					week:[],
					appointment_num:0,
					appointment_advance:0,
					appointment_interval:0,
					check_member_project:0,
					artificer:'',
					rest_notice:'',
				},
			}
		},
		created() {
			this.loaddata();
		},
		methods:{
			loaddata(){
				if(this.loading==true) return;
				this.loading=true;
				this.$http.api('admin/showAppointmentSetting').then(res=>{
					if(res.form){
						this.form=res.form;
					}
					this.loading=false;
				}).catch(res=>{
					console.log(res);
					this.loading=false;
				})
			},
			
			
			/**
			 * 选中权限
			 * @param {Object} index
			 */
			addWeek(index) {
				if (this.form.week.indexOf(this.weeks[index].id) != -1) {
					this.$message.error("已有这个权限");
				}
				this.form.week.push(this.weeks[index].id);
				console.log(this.weeks);
			},
			
			/**
			 * 取消选择权限
			 * @param {Object} index
			 */
			removeWeek(index) {
				let startIndex = this.form.week.indexOf(this.weeks[index].id);
				if (startIndex == -1) {
					this.$message.error("已没有这个权限");
				}
				this.form.week.splice(startIndex, 1);
			},
			
			chooseAppointmentIntervalsAct(index){
				this.form.appointment_interval=this.appointment_intervals[index].interval;
			},
			
			onSubmit(){
				if(this.confirmLoading==true) return;
				this.confirmLoading=true;
				this.$http.api('admin/saveAppointmentSetting',{
					appoint_time:this.form.appoint_time,
					week:this.form.week,
					appointment_num:this.form.appointment_num,
					appointment_advance:this.form.appointment_advance,
					appointment_interval:this.form.appointment_interval,
					fictitious_take_count:this.form.fictitious_take_count,
					check_member_project:this.form.check_member_project,
					artificer:this.form.artificer,
					rest_notice:this.form.rest_notice,
				}).then(res=>{
					this.$message.success('保存成功',1,()=>{
						this.confirmLoading=false;
						this.loaddata();
					});
				}).catch(res=>{
					console.log(res);
					this.confirmLoading=false;
				})
			},
		}
	}
</script>

<style>
	.week-no-choose{
		width: 24px;
		height: 24px;
		border: 2px solid #A6AEC2;
	}
	.week-choose{
		width: 24px;
		height: 24px;
		background: #4772FF;
		line-height: 24px;
		text-align: center;
	}
	
	.appointment-interval-item{
		padding: 11px 20px;
		border-radius: 4px;
		border: 1px solid #EBEDF5;
		line-height: 1;
		font-size: 14px;
		font-weight: 500;
		color: #232529;
		margin-right: 10px;
		margin-bottom: 10px;
		cursor: pointer;
	}
	
	.appointment-interval-item.active{
		border: 1px solid #4772FF;
		color: #4772FF;
	}
</style>
